<template>
  <footer id="user_footer">
    <div class="us_wrap">
      <div class="ft_container">
        <div class="ft_item">
          <img src="@/assets/img/layout/user_footer_logo.png" alt="" />
          <p><b>대표</b> : 안가청</p>
          <p><b>사업자 등록번호</b> : 169-94-01307</p>
          <p><b>주소</b> : 서울시 강서구 화곡로63길 93 2층 1호</p>
        </div>
        <div class="ft_item">
          <p><b>E-MAIL</b> : seoulkogiri@gmail.com</p>
          <p>
            <b>입금계좌 하나은행</b> : 569-910031-26104 <b>예금주</b> : 안가청
          </p>
        </div>
      </div>
      <div class="cs_center">
        <span>고객만족센터</span>
        <strong>02.6952.1514</strong>
        <span>CS 상담시간</span>
        <p><b>평일</b> : 오전09:00 - 오후06:00</p>
        <p><b>토요일</b> : 오전09:00 - 오후04:00</p>
        <p>일요일/공휴일 휴무</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "UserFooter",
  data() {
    return {};
  },
};
</script>
